/** Distinct from the Slack key so the two link flows cannot clobber each other. */
export const TEAMS_TOKEN_KEY = 'teams_link_token';
